'use client'
declare global {
  interface Window {
    clarity: ((action: 'set', key: string, value: string) => void) | undefined
  }
}

export const setPageVariantInClarity = (pageVariant: string) => {
  if (window && window?.clarity) {
    try {
      window?.clarity('set', 'page_variant', pageVariant as string)
    } catch (error) {
      // catch to avoid crashing the app if clarity fails
      console.warn('Clarity variant setting failed', error)
    }
  }
}

export const setNavigationVariantInClarity = (navigationVariant: string) => {
  if (window && window?.clarity) {
    try {
      window?.clarity('set', 'navigation_variant', navigationVariant)
    } catch (error) {
      console.warn('Clarity navigation_variant setting failed', error)
    }
  }
}

export const setFooterVariantInClarity = (footerVariant: string) => {
  if (window && window?.clarity) {
    try {
      window?.clarity('set', 'footer_variant', footerVariant)
    } catch (error) {
      console.warn('Clarity footer_variant setting failed', error)
    }
  }
}

export const setAbTestingContextInClarity = (
  componentName: string,
  variant: string,
  cookieName: string,
  value: string
) => {
  if (window && window?.clarity) {
    try {
      window.clarity('set', 'ab_component_name', componentName)
      window.clarity('set', 'ab_variant', variant)
      window.clarity('set', 'ab_cookie_name', cookieName)
      window.clarity('set', 'ab_cookie_value', value)
    } catch (error) {
      // catch to avoid crashing the app if clarity fails
      console.warn('Clarity abTestingContent setting failed', error)
    }
  }
}
